// extracted by css-extract-rspack-plugin
var _1 = "t0KaTnrehFYFlDMB";
export { _1 as "event" }
